// extracted by mini-css-extract-plugin
export default {"container":"MainPageLayout_container__Ot85A","page":"MainPageLayout_page__E2EXY","layoutContent":"MainPageLayout_layoutContent__7F68X"};